import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/** The two top-level flows in Chunaav. */
export type Flow = 'admin' | 'user';

export interface AuthUser {
  id?: number;
  name: string;
  email: string;
  role: string;
  flow: Flow;
}

interface AuthState {
  user: AuthUser | null;
  token: string | null;
}

const USER_KEY = 'chunaav.auth';
// Must match TOKEN_STORAGE_KEY in services/baseApi.ts so requests pick up the token.
const TOKEN_KEY = 'chunaav.token';

function loadInitial(): AuthState {
  try {
    const rawUser = localStorage.getItem(USER_KEY);
    const token = localStorage.getItem(TOKEN_KEY);
    return {
      user: rawUser ? (JSON.parse(rawUser) as AuthUser) : null,
      token: token && token !== 'undefined' ? token : null,
    };
  } catch {
    return { user: null, token: null };
  }
}

const authSlice = createSlice({
  name: 'auth',
  initialState: loadInitial(),
  reducers: {
    setCredentials(state, action: PayloadAction<{ user: AuthUser; token: string }>) {
      state.user = action.payload.user;
      state.token = action.payload.token;
      try {
        localStorage.setItem(USER_KEY, JSON.stringify(action.payload.user));
        localStorage.setItem(TOKEN_KEY, action.payload.token);
      } catch {
        /* ignore persistence errors */
      }
    },
    logout(state) {
      state.user = null;
      state.token = null;
      try {
        localStorage.removeItem(USER_KEY);
        localStorage.removeItem(TOKEN_KEY);
      } catch {
        /* ignore */
      }
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
